/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Divider,
  Form,
  Grid,
  Header,
  Message,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { API, showError } from '../helpers';

const OtherSetting = () => {
  const { t } = useTranslation();
  let [inputs, setInputs] = useState({
    Footer: '',
    Notice: '',
    PlaygroundNoticeEnabled: 'false',
    PlaygroundNoticeTitle: '',
    PlaygroundNoticeContent: '',
    PlaygroundNoticeTutorialTitle: '',
    PlaygroundNoticeTutorialContent: '',
    About: '',
    SystemName: '',
    Logo: '',
    HomePageContent: '',
    Theme: '',
  });
  let [loading, setLoading] = useState(false);
  let [noticeTabActive, setNoticeTabActive] = useState('announcement');
  const getOptions = async () => {
    const res = await API.get('/api/option/');
    const { success, message, data } = res.data;
    if (success) {
      let newInputs = {};
      data.forEach((item) => {
        if (item.key in inputs) {
          newInputs[item.key] = item.value;
        }
      });
      setInputs(newInputs);
    } else {
      showError(message);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getOptions().then();
  }, []);

  const updateOption = async (key, value) => {
    setLoading(true);
    const res = await API.put('/api/option/', {
      key,
      value,
    });
    const { success, message } = res.data;
    if (success) {
      setInputs((inputs) => ({ ...inputs, [key]: value }));
    } else {
      showError(message);
    }
    setLoading(false);
  };

  const handleInputChange = async (e, { name, value }) => {
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const submitNotice = async () => {
    await updateOption('Notice', inputs.Notice);
  };

  const submitPlaygroundNotice = async () => {
    await updateOption(
      'PlaygroundNoticeEnabled',
      inputs.PlaygroundNoticeEnabled || 'false'
    );
    await updateOption('PlaygroundNoticeTitle', inputs.PlaygroundNoticeTitle || '');
    await updateOption('PlaygroundNoticeContent', inputs.PlaygroundNoticeContent || '');
    await updateOption('PlaygroundNoticeTutorialTitle', inputs.PlaygroundNoticeTutorialTitle || '');
    await updateOption('PlaygroundNoticeTutorialContent', inputs.PlaygroundNoticeTutorialContent || '');
  };

  const submitSystemName = async () => {
    await updateOption('SystemName', inputs.SystemName);
  };

  const submitTheme = async () => {
    await updateOption('Theme', inputs.Theme);
  };

  const submitLogo = async () => {
    await updateOption('Logo', inputs.Logo);
  };

  const submitAbout = async () => {
    await updateOption('About', inputs.About);
  };

  const submitOption = async (key) => {
    await updateOption(key, inputs[key]);
  };

  return (
    <Grid columns={1}>
      <Grid.Column>
        <Form loading={loading}>
          <Header as='h3'>{t('setting.other.notice.title')}</Header>
          <Form.Group widths='equal'>
            <Form.TextArea
              label={t('setting.other.notice.content')}
              placeholder={t('setting.other.notice.content_placeholder')}
              value={inputs.Notice}
              name='Notice'
              onChange={handleInputChange}
              style={{ minHeight: 100, fontFamily: 'JetBrains Mono, Consolas' }}
            />
          </Form.Group>
          <Form.Button onClick={submitNotice}>
            {t('setting.other.notice.buttons.save')}
          </Form.Button>

          <Divider />
          <Header as='h3'>{t('setting.other.playground_notice.title')}</Header>
          <Form.Group inline>
            <Form.Checkbox
              checked={inputs.PlaygroundNoticeEnabled === 'true'}
              label={t('setting.other.playground_notice.enabled')}
              name='PlaygroundNoticeEnabled'
              onChange={(e, { checked }) =>
                setInputs((prev) => ({
                  ...prev,
                  PlaygroundNoticeEnabled: checked ? 'true' : 'false',
                }))
              }
            />
          </Form.Group>
          <div style={{ display: 'flex', gap: 0, marginBottom: 16, borderBottom: '1px solid #e0e0e0' }}>
            <button
              type='button'
              onClick={() => setNoticeTabActive('announcement')}
              style={{
                padding: '6px 18px',
                border: 'none',
                borderBottom: noticeTabActive === 'announcement' ? '2px solid #2185d0' : '2px solid transparent',
                background: 'none',
                cursor: 'pointer',
                fontWeight: noticeTabActive === 'announcement' ? 600 : 400,
                color: noticeTabActive === 'announcement' ? '#2185d0' : '#666',
              }}
            >
              {t('setting.other.playground_notice.tab_announcement')}
            </button>
            <button
              type='button'
              onClick={() => setNoticeTabActive('tutorial')}
              style={{
                padding: '6px 18px',
                border: 'none',
                borderBottom: noticeTabActive === 'tutorial' ? '2px solid #2185d0' : '2px solid transparent',
                background: 'none',
                cursor: 'pointer',
                fontWeight: noticeTabActive === 'tutorial' ? 600 : 400,
                color: noticeTabActive === 'tutorial' ? '#2185d0' : '#666',
              }}
            >
              {t('setting.other.playground_notice.tab_tutorial')}
            </button>
          </div>
          {noticeTabActive === 'announcement' && (
            <>
              <Form.Group widths='equal'>
                <Form.Input
                  label={t('setting.other.playground_notice.notice_title')}
                  placeholder={t('setting.other.playground_notice.notice_title_placeholder')}
                  value={inputs.PlaygroundNoticeTitle}
                  name='PlaygroundNoticeTitle'
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.TextArea
                  label={t('setting.other.playground_notice.content')}
                  placeholder={t('setting.other.playground_notice.content_placeholder')}
                  value={inputs.PlaygroundNoticeContent}
                  name='PlaygroundNoticeContent'
                  onChange={handleInputChange}
                  style={{ minHeight: 160, fontFamily: 'JetBrains Mono, Consolas' }}
                />
              </Form.Group>
            </>
          )}
          {noticeTabActive === 'tutorial' && (
            <>
              <Form.Group widths='equal'>
                <Form.Input
                  label={t('setting.other.playground_notice.tutorial_title')}
                  placeholder={t('setting.other.playground_notice.tutorial_title_placeholder')}
                  value={inputs.PlaygroundNoticeTutorialTitle}
                  name='PlaygroundNoticeTutorialTitle'
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.TextArea
                  label={t('setting.other.playground_notice.tutorial_content')}
                  placeholder={t('setting.other.playground_notice.tutorial_content_placeholder')}
                  value={inputs.PlaygroundNoticeTutorialContent}
                  name='PlaygroundNoticeTutorialContent'
                  onChange={handleInputChange}
                  style={{ minHeight: 160, fontFamily: 'JetBrains Mono, Consolas' }}
                />
              </Form.Group>
            </>
          )}
          <Form.Button onClick={submitPlaygroundNotice}>
            {t('setting.other.playground_notice.buttons.save')}
          </Form.Button>

          <Divider />
          <Header as='h3'>{t('setting.other.system.title')}</Header>
          <Form.Group widths='equal'>
            <Form.Input
              label={t('setting.other.system.name')}
              placeholder={t('setting.other.system.name_placeholder')}
              value={inputs.SystemName}
              name='SystemName'
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Button onClick={submitSystemName}>
            {t('setting.other.system.buttons.save_name')}
          </Form.Button>
          <Form.Group widths='equal'>
            <Form.Input
              label={
                <label>
                  {t('setting.other.system.theme.title')}（
                  <Link to='https://github.com/songquanpeng/one-api/blob/main/web/README.md'>
                    {t('setting.other.system.theme.link')}
                  </Link>
                  ）
                </label>
              }
              placeholder={t('setting.other.system.theme.placeholder')}
              value={inputs.Theme}
              name='Theme'
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Button onClick={submitTheme}>
            {t('setting.other.system.buttons.save_theme')}
          </Form.Button>
          <Form.Group widths='equal'>
            <Form.Input
              label={t('setting.other.system.logo')}
              placeholder={t('setting.other.system.logo_placeholder')}
              value={inputs.Logo}
              name='Logo'
              type='url'
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Button onClick={submitLogo}>
            {t('setting.other.system.buttons.save_logo')}
          </Form.Button>

          <Divider />
          <Header as='h3'>{t('setting.other.content.title')}</Header>
          <Form.Group widths='equal'>
            <Form.TextArea
              label={t('setting.other.content.homepage.title')}
              placeholder={t('setting.other.content.homepage.placeholder')}
              value={inputs.HomePageContent}
              name='HomePageContent'
              onChange={handleInputChange}
              style={{ minHeight: 150, fontFamily: 'JetBrains Mono, Consolas' }}
            />
          </Form.Group>
          <Form.Button onClick={() => submitOption('HomePageContent')}>
            {t('setting.other.content.buttons.save_homepage')}
          </Form.Button>
          <Form.Group widths='equal'>
            <Form.TextArea
              label={t('setting.other.content.about.title')}
              placeholder={t('setting.other.content.about.placeholder')}
              value={inputs.About}
              name='About'
              onChange={handleInputChange}
              style={{ minHeight: 150, fontFamily: 'JetBrains Mono, Consolas' }}
            />
          </Form.Group>
          <Form.Button onClick={submitAbout}>
            {t('setting.other.content.buttons.save_about')}
          </Form.Button>
          <Message>{t('setting.other.copyright.notice')}</Message>
          <Form.Group widths='equal'>
            <Form.Input
              label={t('setting.other.content.footer.title')}
              placeholder={t('setting.other.content.footer.placeholder')}
              value={inputs.Footer}
              name='Footer'
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Button onClick={() => submitOption('Footer')}>
            {t('setting.other.content.buttons.save_footer')}
          </Form.Button>
        </Form>
      </Grid.Column>    </Grid>
  );
};

export default OtherSetting;
